import React, {useEffect, useState} from 'react';
import gsap, {TweenLite} from 'gsap';
import _ from 'lodash';

import Hotspot from './Hotspot/Hotspot';

import './Perspectives.sass';
import StandardButton from "../../ui/Button/StandardButton";
import apiJSON from "../../../api/apiJSON";

const Perspectives = ({data, completed, next}) => {
    const [background, setBackground] = useState('');
    const [hotspots, setHotspots] = useState([]);
    const [scenario, setScenario] = useState(null);
    const [feedback, setFeedback] = useState({});
    const [tracking,setTracking] = useState([]);

    useEffect(() => {
        const jsonData = apiJSON.get(data);
        const {scenarios} = jsonData; // get scenarios from JSON
        setScenario(scenarios[0]);
        setBackground(scenarios[0].background);
        setHotspots(scenarios[0].hotspotMap.hotspots);
        let t = [];
        scenarios[0].hotspotMap.hotspots.map(()=>{
            t.push(0);
        });
        setTracking(t)
    }, []);



    const handleClickHotspot = (index) => {
        let feedback = scenario.hotspotMap.hotspots[index].feedback;
        gsap.set('.info-overlay', {visibility: 'visible', opacity: 0});
        gsap.to('.info-overlay', {opacity: 1,duration:0.5});
        setFeedback(feedback);
        let t = tracking.slice();
        t[index] = 1;
        setTracking(t);
    };

    const handleContinue = () => {
        gsap.to('.info-overlay', {
            opacity: 0, duration:0.5, onComplete: () => {
                gsap.set('.info-overlay', {visibility: 'hidden'})
            }
        })
    }

    const finished = () => {
        completed();
        next();
    }

    return (
        <div
            className="situation-activity"
            style={{
                backgroundImage: `url(${background})`,
            }}
        >
            {hotspots.length > 0
                ? hotspots.map((hotspot, index) => (
                    <Hotspot
                        className={`${hotspot.id}-overlay`}
                        style={hotspot.style}
                        key={`overlay-rect-${index}`}
                        index = {index}
                        handleClickHotspot={handleClickHotspot}
                        initialVisible
                        clickable
                    />
                ))
                : null}
            {scenario ? (
                <div className="header-panel">
                    <div className="header-title">
                        {scenario.hotspotMap.title}
                    </div>
                    <div className="header-body">
                        {scenario.hotspotMap.body}
                    </div>
                </div>
            ) : null}
            {feedback ? (
                <div className="info-overlay">
                  <img src={feedback.background} style={{"width":"inherit"}}/>
                    <div
                        className={`full-wrapper absolute ${feedback.location}-0 top-1/4 w-1/2 p-8`}
                    >
                        <div className="feedback-title">{feedback.title}</div>
                        <div className="feedback-body">{feedback.body}</div>
                        <div className="feedback-action-wrapper w-full flex items-center justify-end">
                            <StandardButton data={"continue"}
                                            callback={handleContinue}/>
                        </div>
                    </div>
                </div>
            ) : null}
            <StandardButton className="StandardButton absolute right-0 bottom-8"
                            data={"continue"}
                            disabled={(tracking.indexOf(0)!==-1)}
                            callback={finished}/>
        </div>
    );
};

export default Perspectives;
